import { useReveal } from "@/hooks/useReveal";

const TRUST = ["USDA Organic", "EU Organic", "HACCP", "INVIMA"];

export default function Hero() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section
      id="top"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center"
    >
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/8b2cdea9-defa-4569-b973-50c18ef7f635_compressed_coffe-hero-bg.webp"
          alt="A kraft paper sugar sachet resting on a saucer beside a flat white on a café counter"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative w-full max-w-[1200px] mx-auto px-4 md:px-6 pt-28 md:pt-32 pb-14">
        <div ref={ref} className="reveal w-full lg:max-w-[60%]">
          <h1 className="text-white font-serif text-3xl md:text-5xl font-semibold leading-tight md:leading-[1.15]">
            The one thing on your counter nobody has upgraded yet
          </h1>

          <p className="mt-6 text-cream/90 text-[17px] md:text-lg leading-relaxed max-w-2xl">
            Your coffee is chosen with care. The white sugar sachet next to it
            usually is not. We make organic unrefined cane sugar sachets from
            smallholder farms in Colombia&apos;s coffee region — Ecocert USDA
            and EU Organic certified, with an origin your baristas can actually
            talk about.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#quote"
              className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3.5 rounded-md bg-brand text-white text-base font-semibold hover:bg-brand-dark transition-colors"
            >
              Request counter samples
            </a>
            <a
              href="#formats"
              className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3.5 rounded-md border border-white/60 text-white text-base font-semibold hover:bg-white/10 transition-colors"
            >
              See formats and specifications
            </a>
          </div>

          <div className="mt-9 inline-flex flex-wrap items-center gap-x-6 gap-y-2 bg-white/10 backdrop-blur border border-white/15 rounded-lg px-5 py-3">
            {TRUST.map((item) => (
              <span
                key={item}
                className="flex items-center gap-2 text-cream/90 text-sm whitespace-nowrap"
              >
                <i className="ri-check-line text-brand"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}